module.exports = __webpack_public_path__ + "static/media/rabbit-shadow.48e251c9.png";